import React from 'react';

import { useTranslation } from 'providers/GILT.provider';

const StylistWithEmail = ({ id, email, onSetupPin, showRemovePopup }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="user-email">{email}</div>
      <div>
        <button type="button" className="btn btn-violet" onClick={onSetupPin}>
          {t('composite.sidebarMenu.existingEmailModal.setupButton')}
        </button>
        <button type="button" className="btn btn-outline" onClick={() => showRemovePopup(id, email)}>
          {t('composite.sidebarMenu.existingEmailModal.removeAccessButton')}
        </button>
      </div>
    </>
  );
};

export default StylistWithEmail;
